/**
 * vue-select keeps a placeholder <ul role="listbox"> in the DOM when closed.
 * Deque: hide from all users with display:none (not aria-hidden alone).
 */
export function syncVueSelectListboxAriaHidden() {
  if (typeof document === "undefined" || typeof window === "undefined") return

  document.querySelectorAll('ul[role="listbox"]').forEach((ul) => {
    if (!/^vs\d+__listbox$/.test(ul.id)) return
    const style = window.getComputedStyle(ul)
    const isHidden = style.display === "none" || style.visibility === "hidden"

    if (isHidden) {
      ul.style.display = "none"
      ul.setAttribute("hidden", "")
      ul.removeAttribute("aria-hidden")
    } else {
      ul.style.removeProperty("display")
      ul.removeAttribute("hidden")
      ul.removeAttribute("aria-hidden")
    }
  })
}
